import React from 'react';
import '../styles/WhyChooseUs.css';

const WhyChooseUs = () => {
  return (
    <section className="why-choose-us">
      <div className="container">
        <div className="success-stories">
          <h3 className="success-stories-title">Lives Transformed, Dreams Realized</h3>
          <div className="success-stories-grid">
            <div className="success-story-card">
              <img
                src="/images/healthcare-success.jpeg"
                alt="Healthcare professional in hospital"
                className="success-story-img"
              />
              <div className="success-story-overlay">
                <span>Healthcare Success</span>
              </div>
            </div>
            <div className="success-story-card">
              <img
                src="https://images.unsplash.com/photo-1504307651254-35680f356dfd?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80"
                alt="Construction worker at job site"
                className="success-story-img"
              />
              <div className="success-story-overlay">
                <span>Industrial Growth</span>
              </div>
            </div>
            <div className="success-story-card">
              <img
                src="https://images.unsplash.com/photo-1600880292203-757bb62b4baf?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80"
                alt="Professional achieving career goals"
                className="success-story-img"
              />
              <div className="success-story-overlay">
                <span>Career Achievement</span>
              </div>
            </div>
            <div className="success-story-card">
              <img
                src="/images/new-beginnings.png"
                alt="Family celebrating new opportunity"
                className="success-story-img"
              />
              <div className="success-story-overlay">
                <span>New Beginnings</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
